module.exports = __webpack_public_path__ + "static/media/Foodcourt-2.cf9960ee.webp";